<template>
  <div class="contentBox">
    <div class="container">
      <div class="article">
        <div class="text page-title">Yêu cầu hủy tài khoản game</div>
        <p class="strong">Vui lòng chọn trò chơi mà bạn muốn hủy tài khoản.</p>
        <div class="text">
          Người chơi thân mến, để đảm bảo an toàn cho tài khoản của bạn, vui
          lòng đăng nhập vào trò chơi có chứa tài khoản bạn muốn hủy trước khi
          thực hiện yêu cầu hủy.
        </div>
        <div>
          <el-select
            style="width: 100%"
            v-model="value"
            placeholder="choose game"
          >
            <el-option
              v-for="item in gameData"
              :key="item.game_id"
              :label="item.game_name"
              :value="item.game_id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div
        class="btn mt auto-footer unactive"
        :class="{ active: value }"
        @click="handleClick"
      >
        Next
      </div>
    </div>
    <div class="mt-logo"></div>
  </div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      gameData: [],
      value: "",
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getData();
  },
  mounted() {},
  methods: {
    getData() {
      this.$http.get("/main/index", {}).then((res) => {
        if (res.data.code === 200) {
          // this.gameData = res.data.data.game_list;
          res.data.data.game_list.forEach((item) => {
            item.list.forEach((i) => {
              if (!i.game_name.includes("H5")) {
                this.gameData.push(i);
              }
            });
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleClick() {
      if (!this.value) {
        return;
      }
      this.$router.push({
        path: "/main/deletion/chooseLogin",
        query: {
          g: this.value,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "./css/index.css";
</style>
